import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { getThumbBySize } from '../../../../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../constants/image-size-codes';
import DropdownMenu from '../../../../../../../../../components/global/DropdownMenu';
import DotTrigger from '../../../../../../../../../components/global/DotTrigger';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const Photo = ({ photo }) => {
  const classes = classNames({
    'slideshow-photo-order': true,
  });

  return (
    <div className={classes}>
      <img
        src={getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.MEDIUM)?.url}
        alt=""
      />
    </div>
  );
};

const PhotoSortable = ({ photo, onHide, onDelete, className }) => {
  const {
    isDragging,
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
  } = useSortable({
    id: photo.id,
  });

  const classes = classNames({
    'slideshow-photo-order-sortable': true,
    'is-dragging': isDragging,
    [className]: !!className,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className={classes}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
    >
      <Photo photo={photo} />
      <div className="dropdown-menu-dark">
        <DropdownMenu
          placement="bottom-end"
          toggle={<DotTrigger dotType="vertical" />}
        >
          <button className="dropdown-item text-extra-bold" onClick={onHide}>
            Hide photo
          </button>
          <button
            className="dropdown-item text-extra-bold text-danger"
            onClick={onDelete}
          >
            Delete photo
          </button>
        </DropdownMenu>
      </div>
    </div>
  );
};

PhotoSortable.propTypes = propTypes;

export { Photo };

export default PhotoSortable;
